import { useCallback } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { useSignal } from "@preact/signals-react"
import { BACKEND_APIS } from "@constants"
import { autoEuropeSeasonSetsDrawerData } from "Pages/AutoEuropeTool/SeasonSets/@signals"
import { useToast } from "@hooks"

const SEASON_SETS_API = `${BACKEND_APIS.AUTOEUROPE_PRICING_TOOL}/season-sets`

export default function useAutoEuropeSeasonSetsClone(id) {
	const { showToast } = useToast()
	const isLoading = useSignal(false)

	const onClone = useCallback(() => {
		isLoading.value = true
		getSubmit(`${SEASON_SETS_API}/list`, { id })
			.then(data => {
				const { id: _id, name: _name, ...rest } = data
				autoEuropeSeasonSetsDrawerData.value = { ...rest, name: null }
				isLoading.value = false
			})
			.catch(() => {
				isLoading.value = false
				showToast.error("Error cloning season set")
			})
	}, [id])

	return { onClone, isLoading: isLoading.value }
}
